import _classCallCheck from "D:\\sushrutpandey\\datahubnew\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\sushrutpandey\\datahubnew\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "D:\\sushrutpandey\\datahubnew\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\sushrutpandey\\datahubnew\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\sushrutpandey\\datahubnew\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React, { Component, createRef, PureComponent } from 'react';
import { createPortal, flushSync } from 'react-dom';
import { Calendar } from '@fullcalendar/core';
import { CustomRenderingStore } from '@fullcalendar/core/internal';
var reactMajorVersion = parseInt(String(React.version).split('.')[0]);
var syncRenderingByDefault = reactMajorVersion < 18;
var FullCalendar = /*#__PURE__*/function (_Component) {
  _inherits(FullCalendar, _Component);
  function FullCalendar() {
    var _this;
    _classCallCheck(this, FullCalendar);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(FullCalendar).apply(this, arguments));
    _this.elRef = createRef();
    _this.isUpdating = false;
    _this.isUnmounting = false;
    _this.state = {
      customRenderingMap: new Map()
    };
    _this.requestResize = function () {
      if (!_this.isUnmounting) {
        _this.cancelResize();
        _this.resizeId = requestAnimationFrame(function () {
          _this.doResize();
        });
      }
    };
    return _this;
  }
  _createClass(FullCalendar, [{
    key: "render",
    value: function render() {
      var customRenderingNodes = [];
      var _iterator = _createForOfIteratorHelper(this.state.customRenderingMap.values()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var customRendering = _step.value;
          customRenderingNodes.push(React.createElement(CustomRenderingComponent, {
            key: customRendering.id,
            customRendering: customRendering
          }));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return React.createElement("div", {
        ref: this.elRef
      }, customRenderingNodes);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      // reset b/c react strict-mode calls componentWillUnmount/componentDidMount
      this.isUnmounting = false;
      var customRenderingStore = new CustomRenderingStore();
      this.handleCustomRendering = customRenderingStore.handle.bind(customRenderingStore);
      this.calendar = new Calendar(this.elRef.current, Object.assign(Object.assign({}, this.props), {
        handleCustomRendering: this.handleCustomRendering
      }));
      this.calendar.render();
      // attaching with .on() will cause this to fire AFTER internal preact rendering did flushSync
      this.calendar.on('_beforeprint', function () {
        flushSync(function () {
          // our `customRenderingMap` state will be flushed at this point
        });
      });
      var lastRequestTimestamp;
      customRenderingStore.subscribe(function (customRenderingMap) {
        var requestTimestamp = Date.now();
        var isMounting = !lastRequestTimestamp;
        var runFunc =
        // don't call flushSync if React version already does sync rendering by default
        // guards against fatal errors:
        // https://github.com/fullcalendar/fullcalendar/issues/7448
        syncRenderingByDefault ||
        //
        isMounting || _this2.isUpdating || _this2.isUnmounting || requestTimestamp - lastRequestTimestamp < 100 // rerendering frequently
        ? runNow // either sync rendering (first-time or React 16/17) or async (React 18)
        : flushSync; // guaranteed sync rendering
        runFunc(function () {
          _this2.setState({
            customRenderingMap: customRenderingMap
          }, function () {
            lastRequestTimestamp = requestTimestamp;
            if (isMounting) {
              _this2.doResize();
            } else {
              _this2.requestResize();
            }
          });
        });
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.isUpdating = true;
      this.calendar.resetOptions(Object.assign(Object.assign({}, this.props), {
        handleCustomRendering: this.handleCustomRendering
      }));
      this.isUpdating = false;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.isUnmounting = true;
      this.cancelResize();
      this.calendar.destroy();
    }
  }, {
    key: "doResize",
    value: function doResize() {
      this.calendar.updateSize();
    }
  }, {
    key: "cancelResize",
    value: function cancelResize() {
      if (this.resizeId !== undefined) {
        cancelAnimationFrame(this.resizeId);
        this.resizeId = undefined;
      }
    }
  }, {
    key: "getApi",
    value: function getApi() {
      return this.calendar;
    }
  }]);
  return FullCalendar;
}(Component);
export { FullCalendar as default };
FullCalendar.act = runNow; // DEPRECATED. Not leveraged anymore
var CustomRenderingComponent = /*#__PURE__*/function (_PureComponent) {
  _inherits(CustomRenderingComponent, _PureComponent);
  function CustomRenderingComponent() {
    _classCallCheck(this, CustomRenderingComponent);
    return _possibleConstructorReturn(this, _getPrototypeOf(CustomRenderingComponent).apply(this, arguments));
  }
  _createClass(CustomRenderingComponent, [{
    key: "render",
    value: function render() {
      var customRendering = this.props.customRendering;
      var generatorMeta = customRendering.generatorMeta;
      var vnode = typeof generatorMeta === 'function' ? generatorMeta(customRendering.renderProps) : generatorMeta;
      return createPortal(vnode, customRendering.containerEl);
    }
  }]);
  return CustomRenderingComponent;
}(PureComponent); // Util
// -------------------------------------------------------------------------------------------------
function runNow(f) {
  f();
}